<template>
    <BBPTimerModalSelectCompany
      :companies="companies"
      :companyIsTab="companyIsTab"
      :row="project"
      :error.sync="error"
      :scrollTop="scrollTop"
      :defaultModel="defaultModel"
      @onChangeCompanyTab="onChangeCompanyTab"
      @setSelect="setSelect"
      @onDelete="onDelete"
    />
</template>

<script>
import BBPTimerModalSelectCompany from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalSelectCompany'
import {get, set} from 'lodash'

export default {
  name: 'BBPSelectCompany',
  components: {
    BBPTimerModalSelectCompany
  },
  props: [
    'input',
    'model',
    'project',
    'scrollTop',
    'defaultModel',
    'updateBody',
    'errorText'
  ],
  data: () => ({
    companies: [],
    companyIsTab: false,
    error: false
  }),
  methods: {
    isInputRequired () {
      this.input.required = this.companyIsTab
    },
    onChangeCompanyTab (value) {
      this.companyIsTab = value
      set(this.model, this.input.model, value)
      this.$emit('input', value, this.input)
      this.isInputRequired()
    },
    setSelect (value) {
      const [firstItem] = this.companies
      this.companies = Object.keys(firstItem).length ? [...this.companies, value] : [value]
      const company = this.companies.map((el) => el._id)
      set(this.model, 'companies', company)
      this.project.companiesSelect = company
      this.isInputRequired()
      this.$emit('error', false)
    },
    onDelete (index) {
      this.companies.splice(index, 1)
      if (this.companies.length === 0) {
        this.companies.push({})
        if (this.companyIsTab) {
          this.$emit('error', true)
        }
      }
    },
    setDefault () {
      this.companyIsTab = get(this.model, this.input.model, false)
    },
    setDefaultCompany () {
      const { companies = [{}] } = this.updateBody
      this.companies = companies
      const company = companies.map((el) => el._id)
      const [firstItem] = companies
      this.project.companiesSelect = Object.keys(firstItem).length ? company : []
    }
  },
  watch: {
    errorText (newVal) {
      this.error = !!newVal
    },
    error (newVal) {
      this.$emit('error', newVal)
    }
  },
  beforeMount () {
    this.setDefault()
    this.setDefaultCompany()
    this.error = !!this.errorText
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPSelectCompany/BBPSelectCompany.vue